import React from 'react'
import { SubHeader } from '../Registration/SubHeader'
import { SubFooter } from '../Registration/SubFooter'
import styled from 'styled-components'
import { Direction } from '../Registration/types'

export type Props = {
  children?: React.ReactNode
  currentStep: number
  onChangeStep: (direction: Direction) => void
}

const StyledRegistrationTemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  @media ${props => props.theme.media.sm} {
    width: 642px;
    padding: 2rem 3rem;
    border: 1px solid ${props => props.theme.members.colors.silver._50};
  }
`

const StyledContent = styled.div`
  flex-grow: 1;
  padding: 2rem 0;
  width: 100%;
`

export const StyledRegistrationTemplate: React.FC<Props> = (props: Props) => {
  return (
    <StyledRegistrationTemplateContainer>
      <SubHeader currentStep={props.currentStep} />
      <StyledContent>{props.children}</StyledContent>
      <SubFooter currentStep={props.currentStep} onChangeStep={props.onChangeStep} />
    </StyledRegistrationTemplateContainer>
  )
}
